import * as angular from 'angular'
import { RegistersResource } from './registers-resource.service'

export const registersResource = new RegistersResource()

angular
  .module('webregister.services')
  .factory('registersResource', () => registersResource)
